import EmailTempelateList from './emailTempelateList';

export default EmailTempelateList;



// WEBPACK FOOTER //
// ./src/app/views/admin/emailTempelate/index.js